import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed } from "vue";
import { bonImgUrl } from "../../utils/image-src";
import WebpImage from "@sazka/design-system/src/image/webp-image.vue";

const baseClass = "bonusomat-quests__award-icon";


export default /*@__PURE__*/_defineComponent({
  __name: 'bonusomat-quest-award-icon',
  props: {
    iconName: {}
  },
  setup(__props: any) {

const props = __props;

const iconClass = computed(() => {
    return `${baseClass} ${baseClass}--${props.iconName}`;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(WebpImage, {
    src: _unref(bonImgUrl)(`quests/awardsIcons/${_ctx.iconName.toLowerCase()}`, 'png'),
    class: _normalizeClass(iconClass.value),
    alt: "Ikona odměny"
  }, null, 8, ["src", "class"]))
}
}

})